export default __webpack_public_path__ + "static/media/cohort-group.fa247984.svg";